export var AvatarId;
(function (AvatarId) {
    AvatarId["class1"] = "class-1";
    AvatarId["class2"] = "class-2";
    AvatarId["class3"] = "class-3";
    AvatarId["class4"] = "class-4";
    AvatarId["class5"] = "class-5";
    AvatarId["class6"] = "class-6";
    AvatarId["class7"] = "class-7";
    AvatarId["class8"] = "class-8";
    AvatarId["class9"] = "class-9";
    AvatarId["class10"] = "class-10";
    AvatarId["class11"] = "class-11";
    AvatarId["class12"] = "class-12";
})(AvatarId || (AvatarId = {}));
export var AvatarColor;
(function (AvatarColor) {
    AvatarColor["blue"] = "blue";
    AvatarColor["red"] = "red";
    AvatarColor["yellow"] = "yellow";
    AvatarColor["green"] = "green";
})(AvatarColor || (AvatarColor = {}));
export var ClassNotificationName;
(function (ClassNotificationName) {
    ClassNotificationName["PLACEMENT_TEST_FINISHED"] = "placementTestFinished";
    ClassNotificationName["TEACHER_ONBOARDING"] = "teacherOnboarding";
})(ClassNotificationName || (ClassNotificationName = {}));
export const NUMBER_OF_SELECTABLE_WEEKS_ON_SNAPSHOT = 8;
//# sourceMappingURL=class.js.map